import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioButton } from 'primeng/radiobutton';
import { ReportParameterBase } from './report-parameter-base';

export interface RadioButtonOption {
    key: string;
    label: string;
}

export interface RadioButtonParameterOptions {
    options: RadioButtonOption[];
}

@Component({
    selector: 'app-radio-button-parameter',
    imports: [FormsModule, RadioButton],
    template: `
        <div class="flex flex-col gap-2">
            @for (option of parameterOptions().options; track option.key) {
                <div class="flex items-center gap-2">
                    <p-radiobutton
                        [value]="option.key"
                        [ngModel]="selectedKey()"
                        [name]="parameterKey()"
                        [inputId]="parameterKey() + '_' + option.key"
                        [disabled]="isDisabled()"
                        (ngModelChange)="onSelectionChange($event)"
                    />
                    <label [for]="parameterKey() + '_' + option.key">{{ option.label }}</label>
                </div>
            }
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: RadioButtonParameterComponent,
            multi: true
        }
    ]
})
export class RadioButtonParameterComponent extends ReportParameterBase<string, RadioButtonParameterOptions> {
    selectedKey = signal<string | null>(null);

    onSelectionChange(key: string) {
        this.selectedKey.set(key);
        this.reportWorkspace.setParam(this.parameterKey(), key);
        this.onChange(key);
        this.markTouchedIfNotResetting();
    }

    writeValue(obj: string): void {
        this.selectedKey.set(obj ?? null);
    }
}
